module.exports = __webpack_public_path__ + "static/media/twN.c67814e5.png";